<template>
  <div
    class="ep-tab"
    :class="{
      'ep-tab--active': selected,
      'ep-tab--disabled': isNoModel,
    }"
    v-tooltip.top="tooltipConfig"
    v-on:click="onClick"
  >
    <span class="ep-tab__label">{{ label }}</span>
    <span v-if="!isNoModel" class="ep-tab__r2">
      R² ajustado {{ r2 }}%
    </span>
    <span v-else class="ep-tab__nomodel">Sin modelo — muestra insuficiente</span>
    <i
      v-if="showWarningIcon"
      class="material-icons ep-tab__warning"
      v-tooltip.top="warningsText"
      >warning</i
    >
  </div>
</template>

<script>
import { roundRSquaredAdj } from "./regression-helpers";

export default {
  name: "EffectCard",
  props: {
    effectKey: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    analysis: {
      type: Object,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isNoModel() {
      return !this.analysis || this.analysis.no_model === true;
    },
    r2() {
      return roundRSquaredAdj(this.analysis);
    },
    warnings() {
      return (this.analysis && this.analysis.warnings) || [];
    },
    showWarningIcon() {
      return !this.isNoModel && this.warnings.length > 0;
    },
    warningsText() {
      return this.warnings.join(" ");
    },
    tooltipConfig() {
      if (this.isNoModel && this.warnings.length) {
        return { content: this.warningsText, classes: ["ep-tab-tooltip"] };
      }
      return { content: "" };
    },
  },
  methods: {
    onClick() {
      if (this.isNoModel) return;
      this.$emit("select", this.effectKey);
    },
  },
};
</script>

<style lang="scss" scoped>
.ep-tab {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 1px 13.5px;
  font-family: "Inter", sans-serif;
  cursor: pointer;
  border: none;
  border-radius: 10px 10px 0 0;
  outline: none;
}

.ep-tab:focus-visible {
  outline: 2px solid #2a78d6;
  outline-offset: 2px;
}

.ep-tab__label {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  color: #363636;
}

.ep-tab__r2 {
  font-size: 0.78rem;
  color: #6a6a6a;
  margin-top: 2px;
}

.ep-tab__nomodel {
  font-style: italic;
  font-size: 0.78rem;
  color: var(--no-model-ink, #a12a2a);
  margin-top: 2px;
}

.ep-tab--disabled {
  cursor: default;

  .ep-tab__label {
    color: var(--no-model-ink, #a12a2a);
  }
}

.ep-tab--disabled:hover {
  background: none;
}

.ep-tab--active {
  padding: 10px 16px 13.5px;
  border: 1.5px solid #9246df;
  border-bottom: none;
  background: var(--surface-card, #fff);
  margin-bottom: -1.5px;
  position: relative;
  z-index: 2;
}

.ep-tab:not(.ep-tab--active):not(.ep-tab--disabled):hover .ep-tab__label {
  color: #510087;
}

.ep-tab__warning {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 16px;
  color: #e0a640;
  outline: none;
}

.ep-tab__warning:focus-visible {
  outline: 2px solid #2a78d6;
  outline-offset: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/components/variables-prioritarias/EffectCard.vue